export default __webpack_public_path__ + "static/media/streak-stat-icon.4617ca0b.svg";